import { isPartOfMegaMenu } from './descriptor.is-part-of-megamenu.js';
import { findRenderedDescriptorByPath } from './path.find-rendered-descriptor.js';
import { getPageDescriptorByPath } from './util.get-page-descriptor-by-path.js';

function getRenderedDescriptorByPath(configStore, sitemapStore, path) {
  var _a;
  const pageDescriptor = findRenderedDescriptorByPath(
    sitemapStore.getState(),
    path
  );
  if (pageDescriptor && (pageDescriptor.children || !pageDescriptor.hasChildren)) {
    return pageDescriptor;
  }
  if ((_a = sitemapStore.getState().notFoundPaths) == null ? void 0 : _a.includes(path)) {
    return void 0;
  }
  return Promise.resolve(
    getPageDescriptorByPath(configStore, sitemapStore, path)
  ).then((pageDescriptor2) => {
    if (pageDescriptor2 && isPartOfMegaMenu(sitemapStore.getState(), pageDescriptor2)) {
      return getPageDescriptorByPath(configStore, sitemapStore, "/");
    }
    return pageDescriptor2;
  });
}

export { getRenderedDescriptorByPath };
//# sourceMappingURL=path.get-rendered-descriptor.js.map
